<!-- Preview header: same as the create preview (agreements.component.html) -->
<div class="section-header-bar" [class.section-header-bar--scrolled]="isPageScrolled">
  <div class="section-header">
    <div class="section-header__title">
      <mat-icon class="section-header__icon">description</mat-icon>
      <div>
        <div class="section-header__heading preview-heading">
          Agreement Preview
          <span class="status-badge" [ngClass]="'status-badge--' + statusTone">
            <span class="legend-dot" [ngClass]="'legend-dot--' + statusTone"></span>
            {{ statusTone | uppercase }}
          </span>
        </div>
        <div class="section-header__subtitle">
          Loan Agreement<span *ngIf="statusTone === 'draft'"> - Review before sending to recipients</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="split-view">
  <div class="pane pane--pdf">
    <div *ngIf="pdfSource; else generatingPreview">        
      <ngx-extended-pdf-viewer
        *ngIf="!isGuideOpen"
        id="listViewer" 
        [src]="pdfSource" 
        useBrowserLocale="true"
        [zoom]="'80%'"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showOpenFileButton]="false"
        [showRotateButton]="false"
        [showSecondaryToolbarButton]="false"
        [showDrawEditor]="false"
        [showTextEditor]="false"  
        [showStampEditor]="false"    
        [textLayer]="true"
        (pdfLoaded)="isPdfLoaded = true"
        (textLayerRendered)="onTextLayerRendered($event)">
      ></ngx-extended-pdf-viewer>      
    </div>
    <ng-template #generatingPreview>
      <div class="generating-preview">
          <mat-spinner diameter="30" color="primary"></mat-spinner>
          <p class="loading-text">{{ loaderText }}</p>
      </div>
    </ng-template>
  </div>

  <div class="pane pane--status" [ngClass]="'pane--status--' + statusTone">
    <div class="status-header">
        <span class="action-link" (click)="onBackToList()">
          <mat-icon>arrow_back</mat-icon>
          Back to list
        </span>
        <button *ngIf="isDraft" type="button" class="recipients-toggle"
          [class.recipients-toggle--active]="showRecipients"
          [attr.aria-pressed]="showRecipients"
          (click)="showRecipients = !showRecipients">
          <mat-icon>{{ showRecipients ? 'close' : 'group' }}</mat-icon>
          {{ showRecipients ? 'Close recipients' : 'Manage recipients' }}
        </button>
        <span *ngIf="!isDraft">
          <mat-icon class="action-icon" matTooltip="Docusign guide" (click)="openDocusignGuide()">info_outline</mat-icon>
          <mat-icon class="action-icon" (click)="onRefresh()" matTooltip="Refresh status">refresh</mat-icon>
        </span>
    </div>

    <div class="status-body" *ngIf="!isDraft; else editingMode">
      <app-agreements-recipient-status 
      [envelopeId] = "selectedRowData?.envelope_id"
      [appData] = "dataModel"
      [currentUser] = "selectedRowData?.currentUser"
      ></app-agreements-recipient-status>
    </div>
    <ng-template #editingMode>
      <app-agreement-content-update 
      (applicationChange)="onApplicationChanged($event)"
      [envelopeId] = "selectedRowData?.envelope_id"
      [application] = "selectedRowData?.application"
      [currentUser] = "selectedRowData?.currentUser"
      [showRecipients] = "showRecipients"
      [isDraftReady] = "!!pdfSource && isPdfLoaded"
      [isEnvelopeUpdating] = "isUpdatingEnvelope"
      (recipientsClose)="showRecipients = false"
      ></app-agreement-content-update>
    </ng-template>
  </div>
</div>